import { SendMessage as DLSendMessage } from './../DL/Messages'

import { ValidateSqlInjection as BLValidateSqlInjection } from './Security'


/**
 * Limpia el texto de saltos de línea, tabuladores y espacios dobles.
 * @param {string} text - Texto sucio.
 * @returns {string} - Texto limpio en una sola línea.
 */
const CleanText = (text) => {
    if (!text) return "";
    // Reemplaza cualquier secuencia de espacios en blanco (\n, \t, espacio) por un solo espacio
    // y elimina los espacios al inicio y al final.
    return text.replace(/\s+/g, ' ').trim();
};

/**
 * Procesa el envío del mensaje aplicando reglas de negocio, limpieza y seguridad.
 * @param {Object} formData - Datos del formulario { message, sender, phone }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const SendMessage = async (formData) => {
    try {
        // 1. Limpieza de Datos (Sanitización)
        // Aplicamos la limpieza ANTES de validar longitud o seguridad
        const cleanMessage = CleanText(formData.message);
        const cleanSender = CleanText(formData.sender);
        const cleanPhone = formData.phone ? formData.phone.trim() : null;

        // 2. Validación: Campos vacíos
        if (cleanMessage === '') {
            return { success: false, message: '¡Ups! Has olvidado escribir el mensaje' };
        }

        // 3. Validación: Longitud (Usando ya el texto limpio)
        if (cleanMessage.length > 100) {
            return { success: false, message: 'El mensaje es demasiado largo (máximo 100 caracteres)' };
        }
        if (cleanSender.length > 20) {
            return { success: false, message: 'El nombre es demasiado largo (máximo 20 caracteres)' };
        }

        // 4. Validación: Teléfono (Opcional)
        if (cleanPhone && cleanPhone !== '') {
            // Debe tener entre 10 y 14 caracteres numéricos
            if (cleanPhone.length < 10 || cleanPhone.length > 14) {
                return { success: false, message: 'El teléfono debe tener entre 10 y 14 dígitos' };
            }
            const isPhoneUnsafe = await BLValidateSqlInjection(cleanPhone);
            if (isPhoneUnsafe) {
                return { success: false, message: 'El teléfono contiene caracteres no válidos' };
            }
        }

        // 5. Validación: Seguridad (SQL Injection)
        const isMessageUnsafe = await BLValidateSqlInjection(cleanMessage);
        const isSenderUnsafe = await BLValidateSqlInjection(cleanSender);

        if (isMessageUnsafe || isSenderUnsafe) {
            return { success: false, message: 'Tu mensaje contiene caracteres no permitidos' };
        }

        // 6. Ejecución: Enviar al Data Layer los datos YA LIMPIOS
        const response = await DLSendMessage({
            message: cleanMessage,
            sender: cleanSender !== '' ? cleanSender : 'Anónimo',
            phone: cleanPhone !== '' ? cleanPhone : null
        });

        // 7. Retorno de resultado
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }

    } catch (error) {
        return { success: false, message: 'No ha sido posible enviar tu mensaje. Inténtalo nuevamente o inténtalo más tarde' };
    }
};

// /**
//  * Procesa el envío del mensaje aplicando reglas de negocio y seguridad.
//  * * @param {Object} formData - Datos del formulario { message, sender, phone }
//  * @returns {Promise<{success: boolean, data?: any, message?: string}>}
//  */
// const SendMessage = async (formData) => {
//     try {
//         // 1. Validación: Campos vacíos
//         if (!formData || !formData.message || formData.message.trim() === '') {
//             return { success: false, message: '¡Ups! Has olvidado escribir el mensaje' }
//         }

//         // 2. Validación: Longitud (Doble chequeo, aunque el HTML lo limite)
//         if (formData.message.length > 100) {
//             return { success: false, message: 'El mensaje es demasiado largo (máximo 100 caracteres)' }
//         }
//         if (formData.sender && formData.sender.length > 20) {
//             return { success: false, message: 'El nombre es demasiado largo (máximo 20 caracteres)' }
//         }

//         // 3. Validación: Teléfono (Opcional)
//         if (formData.phone && formData.phone.trim() !== '') {
//             // Debe tener entre 10 y 14 caracteres numéricos
//             if (formData.phone.length < 10 || formData.phone.length > 14) {
//                 return { success: false, message: 'El teléfono debe tener entre 10 y 14 dígitos' }
//             }

//             // Validación de seguridad (SQL Injection) en el teléfono
//             const isPhoneUnsafe = await BLValidateSqlInjection(formData.phone)

//             if (isPhoneUnsafe) {
//                 return { success: false, message: 'El teléfono contiene caracteres no válidos' }
//             }
//         }

//         // 4. Validación: Seguridad (SQL Injection) en textos
//         // Verificamos tanto el mensaje como el remitente
//         const isMessageUnsafe = await BLValidateSqlInjection(formData.message)
//         const isSenderUnsafe = await BLValidateSqlInjection(formData.sender || '')

//         if (isMessageUnsafe || isSenderUnsafe) {
//             return { success: false, message: 'Tu mensaje contiene caracteres no permitidos' }
//         }

//         // 5. Ejecución: Enviar al Data Layer
//         const response = await DLSendMessage({
//             message: formData.message.trim(),
//             sender: formData.sender ? formData.sender.trim() : 'Anónimo',
//             phone: formData.phone ? formData.phone.trim() : null // Pasamos el teléfono o null si está vacío
//         })

//         // 6. Retorno de resultado
//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         return { success: false, message: 'Ocurrió un error inesperado al procesar tu solicitud' }
//     }
// }

export { SendMessage };